<template>
  <validation-observer ref="simpleRules">
    <project-files-item-form />
    <save-button
      :save-action="submitForm"
      :is-disabled="uploading"
    />
  </validation-observer>
</template>

<script>

import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import SaveButton from '@/layouts/components/common/SaveButton.vue'
import ProjectFilesItemForm from '@/views/Projects/elements/ProjectFiles/ItemForm.vue'

export default {
  name: 'Add',
  components: {
    ProjectFilesItemForm,
    ValidationObserver,
    SaveButton,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    uploading() {
      return this.$store.getters['projectFiles/uploading']
    },
    dataItem() {
      return this.$store.getters['projectFiles/dataItem']
    },
    project() {
      return this.$store.getters['projects/dataItem']
    },
    saveData() {
      return this.$store.getters['projectFiles/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.$router.push(`/app/projects/edit/${this.project.id}`)
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    localize('tr')
    this.$store.commit('projectFiles/RESET_DATA_ITEM')
  },
  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.dataItem.id_projects = this.$route.params.id
          this.dataItem.is_secret = 1
          this.$store.dispatch('projectFiles/saveData', this.dataItem)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
